import * as React from "react";

import styled from "@emotion/styled";

const StyledSection = styled.section`
  padding: var(--large) 0;
`;

export interface SectionProps {
  children: JSX.Element | JSX.Element[];
  classNames?: string;
  styles?: React.CSSProperties;
}

export const Section = ({ children, classNames, styles }: SectionProps) => (
  <StyledSection className={classNames} style={styles}>{children}</StyledSection>
);
